import { render, staticRenderFns } from "./FacilityFormContainer.vue?vue&type=template&id=2b618e66&scoped=true&"
import script from "./FacilityFormContainer.vue?vue&type=script&lang=ts&"
export * from "./FacilityFormContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b618e66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
